// extracted by mini-css-extract-plugin
export default {"list":"FAQ_list__B+j7X","item":"FAQ_item__SlEmn","open":"FAQ_open__QsQNb","q":"FAQ_q__1xK3Z","plus":"FAQ_plus__iRblI","aWrap":"FAQ_aWrap__SHSOw","a":"FAQ_a__lFFgs"};